import api from '@/helpers/api_helper';
import { apiUrls } from '@/constant/configure';
import type {
    InstagramConnectResponse,
    InstagramConnectionDto,
    InstagramMediaBatchDto,
    InstagramMediaListDto,
} from '@/types/instagram';

const studio = { baseURL: apiUrls.studio };
const PREFIX = '/api/v1';

export const getInstagramStatus = async (withProfile = false): Promise<InstagramConnectionDto> => {
    const res = await api.get<InstagramConnectionDto>(`${PREFIX}/instagram/status`, {
        ...studio,
        params: withProfile ? { withProfile: true } : undefined,
    });
    return res.data;
};

/**
 * Instagram 연동 시작(OAuth URL 요청).
 * platform/origin 을 함께 보내 서버가 콜백에서 웹은 웹 URL(원격 origin/instagram/callback),
 * 앱은 딥링크로 분기 리다이렉트하도록 한다. (서버 미대응 시 무시됨 → 기존 폴링 폴백)
 */
export const postInstagramConnect = async (): Promise<InstagramConnectResponse> => {
    const body = { platform: 'web', origin: window.location.origin };
    const res = await api.post<InstagramConnectResponse>(`${PREFIX}/instagram/connect`, body, studio);
    return res.data;
};

export const deleteInstagramDisconnect = async (): Promise<void> => {
    await api.delete(`${PREFIX}/instagram/disconnect`, studio);
};

export const getInstagramMedia = async (params: {
    limit?: number;
    after?: string | null;
}): Promise<InstagramMediaListDto> => {
    const res = await api.get<InstagramMediaListDto>(`${PREFIX}/instagram/media`, {
        ...studio,
        params: {
            limit: params.limit ?? 25,
            ...(params.after ? { after: params.after } : {}),
        },
    });
    return res.data;
};

export const getInstagramMediaByIds = async (ids: string[]): Promise<InstagramMediaBatchDto> => {
    const res = await api.get<InstagramMediaBatchDto>(`${PREFIX}/instagram/media/by-ids`, {
        ...studio,
        params: { ids: ids.join(',') },
    });
    return res.data;
};

/** 게시물 발행(캐러셀·캐리커쳐 결과물 → 연결된 IG 계정). 릴스 미포함(이미지 소스만) → 동기 처리. */
export interface InstagramPostRequest {
    mediaType: 'IMAGE' | 'CAROUSEL';
    imageUrls: string[]; // IMAGE=1장, CAROUSEL=2~10장 (공개 URL)
    caption?: string;
    firstComment?: string; // 프로필링크 등 (발행 후 자동 작성)
}
export interface InstagramPostResult {
    ok: boolean;
    mediaId: string;
    permalink: string | null;
    firstCommentPosted: boolean;
}
export const publishInstagramPost = async (body: InstagramPostRequest): Promise<InstagramPostResult> => {
    const res = await api.post<InstagramPostResult>(`${PREFIX}/instagram/posts`, body, studio);
    return res.data;
};
